import { render } from "./FeedTypeList.vue?vue&type=template&id=60faa3ba"
import script from "./FeedTypeList.vue?vue&type=script&lang=js"
export * from "./FeedTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__